import { qsa, contains } from "@fluorescent/dom";
import {
  FadeUpReveal,
  FadeScaleReveal,
  FadeUpSplitReveal,
  intersectionWatcher,
  shouldAnimate,
} from "@/lib/animation";

const selectors = {
  revealItem: ".animation-fade-up-split-reveal, .animation-fade-up-reveal",
};

export default node => {
  let observer = null;
  const revealItems = qsa(selectors.revealItem, node);
  const reveals = [];

  if (shouldAnimate(node)) {
    revealItems.forEach(revealItem => {
      // check which type of reveal needs to be initialized
      if (contains(revealItem, "animation-fade-up-split-reveal")) {
        reveals.push(new FadeUpSplitReveal(revealItem));
      } else if (contains(revealItem, "animation-fade-up-reveal")) {
        reveals.push(new FadeUpReveal(revealItem));
      }
    });

    observer = intersectionWatcher(node, { cb: isVisible });
  }

  function isVisible() {
    let textDelay = 0;
    reveals.forEach(reveal => {
      reveal.play(textDelay);

      if (reveal.type === "FadeUpSplitReveal") {
        textDelay += reveal.lineCount * window.theme.animation.delay;
      } else {
        textDelay += window.theme.animation.delay;
      }
    });
  }

  function open(inner) {
    if (inner) {
      const contentScale = new FadeScaleReveal(inner, { scaleStart: 0.8 });
      contentScale.play();
    }
  }

  function close(inner) {
    if (inner) {
      const contentScale = new FadeScaleReveal(inner, { scaleStart: 0.8 });
      contentScale.reverse();
    }
  }

  return {
    open,
    close,
    destroy() {
      observer?.destroy();
    },
  };
};
